import { FC, memo, ReactNode } from 'react';
import * as styles from './styles';

type Props = {
  children: ReactNode;
};

const OuterWrapper: FC<Props> = ({ children, ...rest }) => (
  <div className={styles.outerWrapper} {...rest}>
    {children}
  </div>
);

export default memo(OuterWrapper);
